
import myBottom from '@/components/myBottom/bottom.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VLine from 'vux/src/components/v-chart/v-line.vue'
import VArea from 'vux/src/components/v-chart/v-area.vue'
import VTooltip from 'vux/src/components/v-chart/v-tooltip.vue'
import VLegend from 'vux/src/components/v-chart/v-legend.vue'
import VBar from 'vux/src/components/v-chart/v-bar.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'

export default {
type: 'dataCenter',
directives: {
TransferDom
},
components: {
'myBottom': myBottom,
Popup,
VChart,
VLine,
VArea,
VTooltip,
VLegend,
VBar,
VScale
},
data () {
return {
listIndex: 0,
data1Type: 1,
data2Type: 1,
year: [{ date: '1', value: '1', type: '1' }],
month: [{ date: '1', value: '1', type: '1' }],
week: [{ date: '1', value: '1', type: '1' }],
week2: [{ date: '1', value: '1', type: '1' }],
month2: [{ date: '1', value: '1', type: '1' }],
year2: [{ date: '1', value: '1', type: '1' }],
totalData: {},
collegeInfo: '',
roleType: 1,
isDataload: false,
isData2load: false
}
},
created () {
this.getPlatformTotal()
this.getCollegeList()
this.roleType = this.getCookie('roleType')
},
filters: {
formatNum: function (val) {
if (val / 10000 > 10) {
return (val / 10000).toFixed(2) + ' 万'
} else {
return val
}
}
},
methods: {
tocollegeList () {
window.location.href = '/h5/schoollist?backurl=' + window.location.href + '&type=2'
},
getPlatformTotal () {
var params = new URLSearchParams()

this.$http({
method: 'post',
url: '/report/getPlatformTotal',
data: params
}).then(res => {
this.totalData = res.result
}).catch(error => {
console.log(error)
})
},

getBarList (type) {
var params = new URLSearchParams()
params.append('collegeid', this.collegeInfo.id)
params.append('type', type)
this.$http({
method: 'post',
url: '/report/collegeActivityCount',
params: params
}).then(res => {
let _this = this
if (type === 1) {
this.week = []
res.result.forEach(function (item) {
item.value = parseInt(item.value)
_this.week.push(item)
})
} else if (type === 2) {
this.month = []
res.result.forEach(function (item) {
item.value = parseInt(item.value)
_this.month.push(item)
})
} else {
this.year = []
res.result.forEach(function (item) {
item.value = parseInt(item.value)
_this.year.push(item)
})
this.isDataload = true
}
}).catch(error => {
console.log(error)
})
},

getLineList (type) {
var params = new URLSearchParams()
params.append('collegeid', this.collegeInfo.id)
params.append('type', type)
this.$http({
method: 'post',
url: '/report/collegeActivityJoinTotal',
params: params
}).then(res => {
let _this = this
if (type === 1) {
this.week2 = []
res.result.forEach(function (item) {
item.value = parseInt(item.value)
_this.week2.push(item)
})
} else if (type === 2) {
this.month2 = []
res.result.forEach(function (item) {
item.value = parseInt(item.value)
_this.month2.push(item)
})
} else {
this.year2 = []
res.result.forEach(function (item) {
item.value = parseInt(item.value)
_this.year2.push(item)
})
this.isData2load = true
}
}).catch(error => {
console.log(error)
})
},

getCollegeList () {
if (this.$route.query.id) {
this.collegeInfo = {
id: this.$route.query.id,
name: this.$route.query.name
}
this.getBarList(1)
this.getBarList(2)
this.getBarList(3)
this.getLineList(1)
this.getLineList(2)
this.getLineList(3)
} else {
let pageSource = localStorage.getItem('school_source') 
let url = pageSource === 'v2' ? '/dict/college/select' : '/dict/collegelist'
var params = new URLSearchParams()
params.append('schoolid', this.getCookie('schoolid'))
this.$http({
method: 'post',
url: url,
params: params
}).then(res => {

this.collegeInfo = {
id: res.result[0].key,
name: res.result[0].value
}
this.getBarList(1)
this.getBarList(2)
this.getBarList(3)
this.getLineList(1)
this.getLineList(2)
this.getLineList(3)
}).catch(error => {
console.log(error)
})
}
}
}
}




// WEBPACK FOOTER //
// ./src/components/dataCenter/dataCenter.vue